module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Italic.a6bbae2e.ttf";